import React from "react";
import HeroContent from "./hero/HeroContent";
import HeroStats from "./hero/HeroStats";
import ScrollIndicator from "./hero/ScrollIndicator";

const BuyCarAuctionsHero = () => {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Futuristic car background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.7)), url('/lovable-uploads/d546cc29-0091-45d6-b51e-4f9961a03294.png')`,
        }}
      />

      <div className="container mx-auto px-4 pt-20 pb-10 relative z-10">
        <div className="flex flex-col items-center text-center">
          <HeroContent />
          <HeroStats />
        </div>
      </div>

      <ScrollIndicator />
    </div>
  );
};

export default BuyCarAuctionsHero;
